module.exports = __webpack_public_path__ + "img/main-qimg-ae44ee18db5078485b0955f941260386.cdbc3f67.png";